<template>
  <ai-carousel-with-sections
    v-model="currentStep"
    :title="$t('hotel.hotelFacilities.title')"
    access-id="HotelBarsAndRestaurantsCarousel"
    mobile-size="2"
    :items="items"
    :sections="sections"
    mobile-button
    :slide-width="slideWidth"
    :gutter="gutter"
    horizontal-tabs
    tabs-variant="tab-link-02"
    hide-gallery
    arrows-top-position="10%"
    tabs-size="small" />
</template>

<script setup lang="ts">
import FacilityCard from './FacilityCard.vue';

import type { Facility, FacilitySection } from '~~/domains/graphql';
import type { AiCarouselItem } from '~~/domains/ux/molecules/AiCarousel/types';

export interface AiCarouselItemWithSection extends AiCarouselItem {
  sectionId: string;
}

type Props = {
  sections: FacilitySection[];
};

const props = defineProps<Props>();

const currentStep = ref<number>(1);

const isSmallDevice = useMatchMediaQuery('tablet');
const isDesktopDevice = useMatchMediaQuery('large-desktop');

const gutter = computed(() => {
  if (isSmallDevice.value) return 16;

  return isDesktopDevice.value ? 64 : 32;
});
const slideWidth = computed(() => (isSmallDevice.value ? 0.9 : 0.333));

const sections = computed(() =>
  props.sections.map(section => ({
    id: section.id,
    label: section.title as string,
  })),
);

const items = computed(() => {
  const carouselItems: AiCarouselItemWithSection[] = [];

  for (const section of props.sections) {
    const sectionItems = section.entries.filter(Boolean).map(entry => ({
      component: FacilityCard,
      key: entry?.id,
      props: entry as Facility,
      sectionId: section.id,
    }));

    carouselItems.push(...sectionItems);
  }

  return carouselItems;
});
</script>
